'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _fa = require('react-icons/lib/fa');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Geolocation = require('../Geolocation');

var _Geolocation2 = _interopRequireDefault(_Geolocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocatorSearch = (_dec = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PickupLocatorSearch, _React$Component);

  function PickupLocatorSearch(props) {
    (0, _classCallCheck3.default)(this, PickupLocatorSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PickupLocatorSearch.__proto__ || (0, _getPrototypeOf2.default)(PickupLocatorSearch)).call(this, props));

    _this.state = { term: props.gps ? '' : props.term };
    return _this;
  }

  (0, _createClass3.default)(PickupLocatorSearch, [{
    key: 'setSearch',
    value: function setSearch(e) {
      this.setState({ term: e.currentTarget.value });
    }
  }, {
    key: 'search',
    value: function search(e) {
      e.preventDefault();
      this.props.search(this.state.term);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { styleName: 'header' },
          'Search by address'
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: this.search.bind(this), styleName: 'container' },
          _react2.default.createElement('input', {
            styleName: this.props.gps ? 'box gps' : 'box',
            type: 'search',
            placeholder: this.props.gps ? 'Your location' : '',
            value: this.state.term,
            onChange: this.setSearch.bind(this)
          }),
          _react2.default.createElement(
            _Geolocation2.default,
            {
              search: this.props.search,
              gpsUnavailable: this.props.gpsUnavailable,
              canUseGps: this.props.canUseGps
            },
            _react2.default.createElement(
              'div',
              { role: 'button', styleName: 'locate' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_fa.FaCrosshairs, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { role: 'button', styleName: 'search', onClick: this.search.bind(this) },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_fa.FaSearch, null)
            )
          )
        )
      );
    }
  }]);
  return PickupLocatorSearch;
}(_react2.default.Component), _class2.propTypes = {
  term: _react.PropTypes.string.isRequired,
  search: _react.PropTypes.func.isRequired,
  gps: _react.PropTypes.bool.isRequired,
  gpsUnavailable: _react.PropTypes.func.isRequired
}, _class2.defaultProps = { term: '' }, _temp)) || _class);
exports.default = PickupLocatorSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Search/index.js
// module id = 601
// module chunks = 0